import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0f3cd94"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "activeCard",
  class: "active-card"
}
const _hoisted_2 = { class: "active-card__infoBlock-imgBlock relative" }
const _hoisted_3 = {
  key: 0,
  class: "active-card__infoBlock-partners"
}
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  key: 0,
  class: "partners-icon"
}
const _hoisted_6 = { class: "items-in-line gap--10 mb--25" }
const _hoisted_7 = {
  key: 0,
  class: "active-card__infoBlock-area"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Дом: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Этаж: ", -1))
const _hoisted_10 = { class: "active-card__infoBlock-type" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Участок: ", -1))
const _hoisted_12 = { class: "active-card__infoBlock-type-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Тип: ", -1))
const _hoisted_14 = { class: "active-card__infoBlock-address" }
const _hoisted_15 = {
  key: 1,
  class: "active-card__infoBlock-description"
}
const _hoisted_16 = {
  key: 2,
  class: "active-card__infoBlock-description"
}
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "active-card__infoBlock-topIcons" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "active-card__infoBlock-phone" }
const _hoisted_21 = { class: "active-card__infoBlock-chat" }
const _hoisted_22 = { class: "active-card__infoBlock-bottomIcons" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "active-card__infoBlock-seller-box" }
const _hoisted_26 = { class: "active-card__infoBlock-seller-title" }
const _hoisted_27 = { class: "active-card__calcBlock" }
const _hoisted_28 = { class: "active-card__calcBlock-top" }
const _hoisted_29 = { class: "active-card__calcBlock-top-price" }
const _hoisted_30 = { class: "active-card__calcBlock-top-btn" }
const _hoisted_31 = { class: "active-card__calcBlock-bottom" }
const _hoisted_32 = {
  key: 0,
  class: "active-card__calcBlock-bottom-rates-box"
}
const _hoisted_33 = { class: "active-card__calcBlock-bottom-textBox" }
const _hoisted_34 = { class: "medium mb--5" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "only-PC" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "none-PC" }, "-", -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "blue-color" }
const _hoisted_40 = {
  key: 1,
  class: "active-card__calcBlock-bottom-rates-box"
}

import { ResultCardType } from '@/types';
import { computed, onMounted, ref, Ref, watch } from 'vue';
import { useAppStore } from '@/store/modules/app';
import { ComplainModal } from '@/components';
import {
  CompareIcon,
  InfographicImgs,
  SaveDocsBtn,
} from '@/components/Cards/CardsComponents';
import { useUserStore } from '@/store/modules/user';
import { useChatStore } from '@/store/modules/chat';
import PhoneButton from '../../../../PhoneButton/PhoneButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActiveOfferCard',
  props: {
    card: {}
  },
  emits: ['updateActiveBlock', 'changeActive'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const window = computed((): number => {
  return useAppStore().window;
});

const showFurther = ref(false);
const showEnlargedBlock = ref(false);
const showComplainModal = ref(false);
const infographicHeight: Ref<number | undefined> = ref(undefined);
const changeIsFavorite = (cardId: number) => {
  if (useUserStore().user) {
    useUserStore().changeIsFavorite(cardId);
  } else {
    useAppStore().openAuthModal(true);
  }
};

const openComplainModal = () => {
  if (useUserStore().getIsLogin()) {
    showComplainModal.value = true;
  } else {
    useAppStore().openAuthModal(true);
  }
};

const description = computed((): string => {
  let sliced: string;

  if ((infographicHeight.value && infographicHeight.value > 40) || window.value < 1264) {
    sliced = props.card.description?.slice(0, 250);
  } else {
    sliced = props.card.description?.slice(0, 420);
  }

  if (sliced?.length < props.card.description?.length) {
    showFurther.value = true;
  }

  return sliced;
});

const pricePerMeter = computed((): string => {
  if (
    props.card.id === props.card.landId &&
    props.card.price !== '-' &&
    props.card.price &&
    props.card.landArea !== '-' &&
    props.card.landArea
  ) {
    return Math.round(+props.card.price / +props.card.landArea).toLocaleString();
  }
  if (
    props.card.price !== '-' &&
    props.card.houseArea !== '-' &&
    props.card.houseArea &&
    props.card.price &&
    props.card.houseArea
  ) {
    return Math.round(+props.card.price / +props.card.houseArea).toLocaleString();
  }

  return '-';
});

const enlargeBlock = () => {
  showEnlargedBlock.value = !showEnlargedBlock.value;
  emit('updateActiveBlock');
};

onMounted(() => {
  setTimeout(() => {
    infographicHeight.value = document.getElementById(
      `infographic${props.card.id}`,
    )?.offsetHeight;
  }, 100);
});
watch(
  () => window.value,
  () => {
    emit('updateActiveBlock');
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_brazzers_carousel = _resolveComponent("base-brazzers-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_card, {
      class: _normalizeClass([{ enlargedBlock: showEnlargedBlock.value }, "active-card__infoBlock"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_icon, {
          class: "active-card__infoBlock-close-icon",
          clickable: "",
          color: "#94857d",
          "font-size": "18",
          name: "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeActive', _ctx.card.id)))
        }),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.card.affiliateProgramId && _ctx.card.isEstateAgent)
            ? (_openBlock(), _createElementBlock("button", _hoisted_3, " ₽ "))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: { name: 'offerCard', params: { url: _ctx.card.landUrl } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, [
                (_ctx.card.affiliateProgramId)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_5, "₽"))
                  : _createCommentVNode("", true),
                _createVNode(_component_base_brazzers_carousel, {
                  alt: _ctx.card.address,
                  photos: 
                _ctx.card.id === _ctx.card.landId ? _ctx.card.landImgs : [..._ctx.card.img, ..._ctx.card.landImgs]
              ,
                  title: _ctx.card.address,
                  borderRadius: "",
                  class: "mb--15",
                  height: "129",
                  version: "x8",
                  width: "240"
                }, null, 8, ["alt", "photos", "title"]),
                (!_ctx.card.isPhysics)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: { name: 'checkResult', query: { id: _ctx.card.landId } },
                      class: "verifiedBtn verifiedBtn-text center"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Проверено ")
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_base_image, {
                  name: String(_ctx.card.id),
                  src: _ctx.card.img ? _ctx.card.img[1] : _ctx.card.landImgs[1],
                  borderRadius: "",
                  cover: "",
                  height: "80",
                  version: "x9",
                  width: "115"
                }, null, 8, ["name", "src"]),
                _createVNode(_component_base_image, {
                  name: String(_ctx.card.id),
                  src: _ctx.card.img ? _ctx.card.img[2] : _ctx.card.landImgs[2],
                  borderRadius: "",
                  cover: "",
                  height: "80",
                  version: "x9",
                  width: "115"
                }, null, 8, ["name", "src"])
              ])
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.card.rating !== undefined)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'classification', query: { id: _ctx.card.landId } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_base_progress_bar, {
                    "max-rate": _ctx.card.classifier?.maxRate,
                    rating: _ctx.card.rating
                  }, null, 8, ["max-rate", "rating"])
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_router_link, {
          to: { name: 'offerCard', params: { url: _ctx.card.landUrl } },
          class: "active-card__infoBlock-title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.card.abbreviation), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        (_ctx.card.landId !== _ctx.card.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(`${_ctx.card.houseArea || '-'} м²`), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.card.floor), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(`${_ctx.card.landArea || '-'} сот.`), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(_ctx.card.type || '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.card.address), 1),
        (showEnlargedBlock.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createTextVNode(_toDisplayString(_ctx.card.description) + " ", 1),
              _createElementVNode("span", { onClick: enlargeBlock }, "Свернуть")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createTextVNode(_toDisplayString(description.value) + " ", 1),
              (showFurther.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    onClick: enlargeBlock
                  }, "Далее"))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", {
          id: `infographic${_ctx.card.id}`,
          class: "active-card__infoBlock-info"
        }, [
          _createVNode(_unref(InfographicImgs), {
            infographics: _ctx.card.infographics,
            "is-green": false
          }, null, 8, ["infographics"])
        ], 8, _hoisted_17),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_base_button, {
            icon: "",
            "style-type": "border",
            withoutActive: "",
            onClick: openComplainModal
          }, {
            icon: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/assets/img/mainPage/icons/icon-i.png'),
                alt: "i"
              }, null, 8, _hoisted_19)
            ]),
            _: 1
          }),
          (_ctx.card.docs.length)
            ? (_openBlock(), _createBlock(_unref(SaveDocsBtn), {
                key: 0,
                docs: _ctx.card.docs
              }, null, 8, ["docs"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(CompareIcon), {
            card: _ctx.card,
            "with-border": ""
          }, null, 8, ["card"]),
          _createVNode(_component_base_button, {
            icon: "",
            "style-type": "border",
            withoutActive: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeIsFavorite(_ctx.card.landId)))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_base_icon, {
                color: _unref(useUserStore)().getIsFavorite(_ctx.card.landId) ? '#EA1F1F' : '#969696',
                "font-size": "20",
                name: "favorite",
                width: "22"
              }, null, 8, ["color"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(PhoneButton, {
            phone: _ctx.card.phone,
            height: "28"
          }, null, 8, ["phone"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_base_button, {
            height: "28",
            "style-type": "coloredBorder",
            text: "Чат",
            width: "85",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(useChatStore)().openMiniMessenger(_ctx.card)))
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.card.coordinates)
            ? (_openBlock(), _createBlock(_component_base_button, {
                key: 0,
                href: {
            name: 'offerCard',
            params: { url: _ctx.card.landUrl },
            hash: '#map',
          },
                icon: "",
                "style-type": "coloredBorder",
                withoutActive: ""
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/img/mainPage/icons/icon-map.png'),
                    alt: "map"
                  }, null, 8, _hoisted_23)
                ]),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, {
            to: { name: 'offerCard', params: { url: _ctx.card.landUrl } }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                icon: "",
                "style-type": "coloredBorder",
                withoutActive: ""
              }, {
                icon: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('@/assets/img/mainPage/icons/icon-eye.png'),
                    alt: "eye"
                  }, null, 8, _hoisted_24)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        (_ctx.card.aboutDeveloper)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: {
          name: 'developer',
          params: { url: _ctx.card.aboutDeveloper.url },
        },
              class: "items-in-line gap--10 active-card__infoBlock-seller"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_base_image, {
                    src: _ctx.card.aboutDeveloper?.logo[0],
                    contain: "",
                    height: "50",
                    name: "seller",
                    version: "v2",
                    width: "74"
                  }, null, 8, ["src"]),
                  _createVNode(_component_base_divider, { vertical: "" }),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.card.aboutDeveloper.title), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createElementVNode("div", _hoisted_27, [
      _createVNode(_component_base_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.card.price ? _ctx.card.price.toLocaleString() : '-') + " ₽ ", 1),
            _createElementVNode("div", null, _toDisplayString(`За м²: ${pricePerMeter.value} ₽`), 1),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_base_button, {
                href: {
                name: 'offerCard',
                params: { url: _ctx.card.landUrl },
                hash: '#mortgage',
              },
                height: "28",
                "style-type": "coloredBorder",
                text: "К расчету",
                width: "164"
              }, null, 8, ["href"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_base_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_31, [
            (_ctx.card.rates?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.rates, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_34, _toDisplayString(item.title) + ":", 1),
                          (item.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("span", _hoisted_36, _toDisplayString(item.error), 1),
                                _hoisted_37
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createTextVNode(" от "),
                                _createElementVNode("span", _hoisted_39, _toDisplayString(item?.minRate) + "%", 1),
                                _createTextVNode(" | " + _toDisplayString(item.minPayment?.toLocaleString()) + " ₽ ", 1)
                              ]))
                        ]),
                        (i !== _ctx.card.rates?.length - 1)
                          ? (_openBlock(), _createBlock(_component_base_divider, {
                              key: 0,
                              vertical: window.value <= 820 && window.value > 600
                            }, null, 8, ["vertical"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, " Скоро здесь появятся доступные ипотечные программы ")),
            _createVNode(_component_base_button, {
              disabled: !_ctx.card.rates?.length,
              href: {
              name: 'offerCard',
              params: { url: _ctx.card.landUrl },
              hash: '#mortgage',
            },
              class: "active-card__calcBlock-bottom-btn",
              height: "28",
              "style-type": "coloredBorder",
              text: "К расчету",
              width: "164"
            }, null, 8, ["disabled", "href"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(ComplainModal), {
        "entity-id": _ctx.card.landId,
        "show-modal": showComplainModal.value,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (showComplainModal.value = false))
      }, null, 8, ["entity-id", "show-modal"])
    ])
  ]))
}
}

})